module.exports = __webpack_public_path__ + "static/assets/476a789ea546f4ecf3a29e4c06670b2e.svg";